/*
 * The route guard for every authenticated admin route (flows/admin-auth). Three gates, in order:
 * no token → /login; a pending forced reset → /reset-password (the must-reset operator cannot reach
 * any other route until the flag clears); otherwise render the matched route. It is a layout route,
 * so it wraps its children via <Outlet />.
 */
import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuth } from '../session/admin-auth-context';

export function RequireAuth() {
  const { claims } = useAdminAuth();

  if (claims === null) {
    return <Navigate to="/login" replace />;
  }
  if (claims.mustResetPw) {
    return <Navigate to="/reset-password" replace />;
  }
  return <Outlet />;
}
